module.exports = __webpack_public_path__ + "assets/icon-star-rating-outline.5f52d403.svg";